import { createUpdater } from ".";
import { create } from "zustand";
const audioStoreUpdater = createUpdater();
export const useAudioStore = create((set) => ({
    audioState: {
        originalAudio: null,
        pcm16: null,
        base64: null,
        isRecording: false,
        isPlaying: false,
        transcription: "",
        userHasStopped: false
    },
    setAudioState: audioStoreUpdater("audioState")(set),
}));
